import { getDocumentUrl } from './api'

/**
 * Единая точка правок юридических ссылок itansar.ru.
 * Ссылки задаются только здесь; документы могут храниться на общем docs-сервере
 * или открываться через ansarium.ru (md-viewer).
 *
 * Сайт Ансариум (другой лендинг) — отдельный реестр: `ansarium/src/shared/config/ansarium-legal-documents.ts`.
 */
export const ITANSAR_LEGAL = {
    termsOfUse: {
        title: 'Условия использования',
        url: 'https://main.ansarium.ru/md/MToxNjE1ODox.Kfqtmryh1NDpButTUX_EUdkzLpky7vSzpeliPptbvCk?file=itansar-terms-of-use.md&teacher=%231+%D0%90%D0%B4%D0%BC%D0%B8%D0%BD%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%82%D0%BE%D1%80&upload=1776974329&from=https://itansar.ru',
    },
    privacyPolicy: {
        title: 'Политика защиты и обработки персональных данных',
        url: getDocumentUrl('2026_04_01_Политика_конфиденциальности_itansar_ru_ИП.pdf'),
    },
    cookiePolicy: {
        title: 'Политика использования файлов cookie',
        url: 'https://main.ansarium.ru/md/MToxNjE1Njox.a44Q36Ap9pU19JRcCLKG_MTxfEg8BLaH68J9io9d8g4?file=itansar-cookie-policy.md&teacher=%231+%D0%90%D0%B4%D0%BC%D0%B8%D0%BD%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%82%D0%BE%D1%80&upload=1776974316&from=https://itansar.ru',
    },
    consentPersonalData: {
        title: 'Согласие посетителя сайта на обработку персональных данных',
        url: 'https://main.ansarium.ru/md/MToxNzIxMzox.T1hre0Pf1ZE8rHju8hGH2RlDJvr2u2qAODXX6PMVngQ?file=itansar-consent-personal-data.md&teacher=%231+%D0%90%D0%B4%D0%BC%D0%B8%D0%BD%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%82%D0%BE%D1%80&upload=1778090065&from=https://itansar.ru',
    },
} as const

export type ItansarLegalDocKey = keyof typeof ITANSAR_LEGAL
